// extracted by mini-css-extract-plugin
module.exports = {"registerSuccess":"RegisterSuccess_registerSuccess__12WU5"};